function normalizeVoucherType(voucherType: string) {
  if (voucherType?.toLowerCase().includes('pte')) {
    return 'PTE';
  }

  if (voucherType?.toLowerCase().includes('duolingo')) {
    return 'DUOLINGO';
  }

  if (voucherType?.toLowerCase().includes('gre')) {
    return 'GRE';
  }

  if (voucherType?.toLowerCase().includes('toefl')) {
    return 'TOEFL';
  }

  return voucherType;
}

export default normalizeVoucherType;
